import { render, staticRenderFns } from "./BlogComments.vue?vue&type=template&id=48e8bdd6"
import script from "./BlogComments.vue?vue&type=script&lang=js"
export * from "./BlogComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports